import Request from "./request";

const Form = "/forms";

export default {
  async getForm(query) {
    return Request.get(Form, query);
  },
  async getFormId(id) {
    return Request.get(`${Form}/${id}`);
  },
  async getFormField(id) {
    return Request.get(`${Form}/${id}/fields`);
  }
};
